// Константы для размеров
const FLEX_WIDTHS = {
  /** Сумма нижнего ряда: QUANTITY+PRICE+SUM+ACCRUED_INTEREST+DATE — «Покупка» */
  PURCHASE: '49%',
  /** CURRENCY+CURRENCY_IN_FOREIGN — «Текущая оценка» */
  CURRENT_ESTIMATE: '22%',
  /** DIFFERENCE_CURRENCY — «Разница» */
  DIFFERENCE: '12%',
  /** PERIOD+ACTUAL+ANNUAL — «Доходность» */
  PROFITABILITY: '17%',
  QUANTITY: '9%',
  PRICE: '13%',
  SUM: '10%',
  ACCRUED_INTEREST: '9%',
  DATE: '8%',
  CURRENCY: '11%',
  CURRENCY_IN_FOREIGN: '11%',
  DIFFERENCE_CURRENCY: '12%',
  PERIOD: '5%',
  ACTUAL: '6%',
  ANNUAL: '6%',
};

const FONT_SIZE = '12px';

export { FONT_SIZE, FLEX_WIDTHS };
